import React from "react";
import { Button } from "react-bootstrap";

interface Suggestion {
  label: string;
  value: string;
}

interface Props {
  suggestions: Suggestion[];
  currentValue: string;
  onSuggestionClick: (value: string) => void;
}

/** Suggestions for text that users can quickly add to an input field */
const SuggestionButtons: React.FC<Props> = ({
  suggestions,
  currentValue,
  onSuggestionClick,
}) => {
  return (
    <>
      {suggestions
        .filter(
          (suggestion) =>
            // allow punctuation to be ignored in case user adds details manually
            !currentValue.includes(
              suggestion.value.substring(0, suggestion.value.length - 1),
            ),
        )
        .map((suggestion, index) => (
          <Button
            key={index}
            size={"sm"}
            variant={"outline-primary"}
            onClick={() => onSuggestionClick(suggestion.value)}
          >
            {suggestion.label}
          </Button>
        ))}
    </>
  );
};

export default SuggestionButtons;
